import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  listItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 1.5),
    borderBottom: theme.custom.border.secondary,
  },
  listname: {
    fontSize: "14px",
    letterSpacing: "normal",
    lineHeight: "16px",
    fontWeight: "bold",
    color: theme.custom.color.blackRussian,
  },
  hover: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
    },
  },
  listBtnGrp: {
    display: "flex",
    flexDirection: "row",
  },
  delete: {
    display: "flex",
    color: theme.custom.color.pewter,
    padding: theme.spacing(0.75, 0),
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.custom.linkHover.color,
    },
  },
}));
